<template>
  <div>
    <div class="wrapper">
      <div class="logo">
        <div class="logoStart fl">
          <a href="/"><img src="../assets/logo.png" alt="" /></a>
        </div>
        <div class="index_search fr">
          <el-input
            placeholder="关键词搜索"
            v-model="searchWords"
            class="input-with-select"
            width="228"
            @change="handleSearch"
          >
            <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
          </el-input>
        </div>
      </div>
      <div class="wrapMenu">
        <div class="menu">
          <el-menu
            :default-active="$route.fullPath"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
            background-color="#108ee9"
            text-color="#fff"
            active-text-color="#fff"
          >
            <el-menu-item index="/gctc-portalsite" class="menu_height"
              >首页</el-menu-item
            >
            <el-submenu index="/gctc-portalsite/newsCenter" class="menu_height" style="width:170px !important">
              <span slot="title" @click="handleCenter('ZXDT')">中心动态</span>
              <el-menu-item index="/gctc-portalsite/newsCenter?value=ZXYW"
                >中心要闻</el-menu-item
              >
              <el-menu-item index="/gctc-portalsite/newsCenter?value=TZGG"
                >通知公告</el-menu-item
              >
              <el-menu-item index="/gctc-portalsite/newsCenter?value=JYYG"
                >交易预告</el-menu-item
              >
            </el-submenu>
            <el-submenu index="/gctc-portalsite/counsel" class="menu_height">
              <span slot="title" @click="handleCenter('XWZX')">新闻资讯</span>
              <el-menu-item index="/gctc-portalsite/counsel?value=SZYW"
                >时政要闻</el-menu-item
              >
              <el-menu-item index="/gctc-portalsite/counsel?value=HYDT"
                >行业动态</el-menu-item
              >
            </el-submenu>
            <el-submenu index="/gctc-portalsite/business" class="menu_height">
              <span slot="title" @click="handleCenter('QYWH')">企业文化</span>
              <el-menu-item index="/gctc-portalsite/business?value=QYLN"
                >企业理念</el-menu-item
              >
              <el-menu-item index="/gctc-portalsite/business?value=QYBS"
                >企业标识</el-menu-item
              >
              <el-menu-item index="/gctc-portalsite/business?value=YGFC"
                >员工风采</el-menu-item
              >
              <el-menu-item index="/gctc-portalsite/business?value=QYWHJS"
                >企业文化建设</el-menu-item
              >
            </el-submenu>
            <el-submenu index="/gctc-portalsite/party" class="menu_height">
              <span slot="title" @click="handleCenter('DDJS')">党的建设</span>
              <el-menu-item index="/gctc-portalsite/party?value=DJDT"
                >党建动态</el-menu-item
              >
              <el-menu-item index="/gctc-portalsite/party?value=DFLZ"
                >党风廉政</el-menu-item
              >
              <el-menu-item index="/gctc-portalsite/party?value=QTGZ"
                >群团工作</el-menu-item
              >
            </el-submenu>
            <el-submenu class="menu_height" index="1">
              <span slot="title" @click="handleCenter('JYPT')">交易平台</span>
              <!-- <el-menu-item>
                <a
                  href="https://gsmtjyzx.com/ctp-web/"
                  style="text-decoration: none; color: #fff"
                  target="_blank"
                  >电子交易平台</a
                >
              </el-menu-item> -->
              <div class="menu-item01">
                <a
                  href="https://gsmtjyzx.com/ctp-web/"
                  style="text-decoration: none; color: #fff"
                  target="_blank"
                  >电子交易平台</a
                >
                <!-- <a
                  href="http://47.101.203.243:8020/ctp-web/login"
                  style="text-decoration: none; color: #fff"
                  target="_blank"
                  >电子交易平台</a
                > -->
              </div>
              <!-- <div class="menu-item01">供应链金融服务平台</div> -->
              <div class="menu-item01" @click="handleFinance()">供应链金融服务平台</div>
              <!-- <div class="menu-item01">大数据分析平台</div> -->
              <div class="menu-item01" @click="handleData()">大数据分析平台</div>
              <!-- <div class="menu-item01">智慧物流平台</div> -->
              <div class="menu-item01" @click="handleLogis()">智慧物流平台</div>
              <!-- <div class="menu-item01">智能仓储平台</div> -->
              <div class="menu-item01" @click="handleIntell()">智能仓储平台</div>
              <!-- <div class="menu-item01">信息资讯平台</div> -->
              <div class="menu-item01" @click="handleInfor()">信息资讯平台</div>
              <div class="menu-item01" @click="handleBuy()">甘肃能化数字化采购管理平台</div>
              <div class="menu-item01">碳排放智能跟踪分析平台</div>
              <!-- <el-menu-item>
                <a
                  href="#"
                  style="text-decoration: none; color: #fff"
                  target="_blank"
                  >供应链金融服务平台</a
                >
              </el-menu-item>
              <el-menu-item>
                <a
                  href="#"
                  style="text-decoration: none; color: #fff"
                  target="_blank"
                  >大数据分析平台</a
                >
              </el-menu-item>
              <el-menu-item>
                <a
                  href="#"
                  style="text-decoration: none; color: #fff"
                  target="_blank"
                  >智慧物流平台</a
                >
              </el-menu-item>
              <el-menu-item>
                <a
                  href="#"
                  style="text-decoration: none; color: #fff"
                  target="_blank"
                  >智能仓储平台</a
                >
              </el-menu-item>
              <el-menu-item>
                <a
                  href="#"
                  style="text-decoration: none; color: #fff"
                  target="_blank"
                  >信息资讯平台</a
                >
              </el-menu-item>
              <el-menu-item>
                <a
                  href="#"
                  style="text-decoration: none; color: #fff"
                  target="_blank"
                  >甘肃能化数字化采购管理平台</a
                >
              </el-menu-item>
              <el-menu-item>
                <a
                  href="#"
                  style="text-decoration: none; color: #fff"
                  target="_blank"
                  >碳排放智能跟踪分析平台</a
                >
              </el-menu-item> -->
            </el-submenu>
            <el-submenu index="/gctc-portalsite/about" class="menu_height">
              <span slot="title" @click="handleCenter('GYWM')">关于我们</span>
              <el-menu-item index="/gctc-portalsite/about?value=QYJS"
                >企业介绍</el-menu-item
              >
              <el-menu-item index="/gctc-portalsite/about?value=ZZJG"
                >组织架构</el-menu-item
              >
              <el-menu-item index="/gctc-portalsite/about?value=QYRY"
                >企业荣誉</el-menu-item
              >
              <el-menu-item index="/gctc-portalsite/about?value=LDGH"
                >领导关怀</el-menu-item
              >
              <el-menu-item index="/gctc-portalsite/about?value=JXTP"
                >精选图片</el-menu-item
              >
              <el-menu-item index="/gctc-portalsite/about?value=XZZX"
                >下载中心</el-menu-item
              >
              <el-menu-item index="/gctc-portalsite/about?value=LXWM"
                >联系我们</el-menu-item
              >
            </el-submenu>
          </el-menu>
        </div>
      </div>
    </div>
    <!-- <div>
    </div> -->
  </div>
</template>

<script>
// import { mapGetters } from "vuex";
// import footerCard from "../../components/footer.vue";

export default {
  name: "Home",
  components: {},
  created() {},
  computed: {
    active() {
      return this.$route.fullPath;
    },
  },
  data() {
    return {
      activeIndex: "/gctc-portalsite",
      gctcStatus: false,
      searchWords: "",
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      if (key == "/gctc-portalsite") {
        this.$router.push("/gctc-portalsite");
      } else {
        let path = key;
        const { href } = this.$router.resolve({
          //path是要跳转到的页面路径
          path: path,
        });
        //结合open打开新的页面
        window.open(href, "_blank");
        // 强制刷新：因为跳转新标签页后 原标签页的导航栏高亮也发生了改变
        this.$router.go(0);
      }
    },
    handleBusiness() {
      this.$router.push({
        path: "/gctc-portalsite/about",
        query: {
          value: "QYJS",
        },
      });
    },
    handleCenter(val) {
      if (val == "ZXDT") {
        this.$router.push({
          path: "/gctc-portalsite/newsCenter",
          query: {
            value: "ZXYW",
          },
        });
      } else if (val == "XWZX") {
        this.$router.push({
          path: "/gctc-portalsite/counsel",
          query: {
            value: "SZYW",
          },
        });
      } else if (val == "QYWH") {
        this.$router.push({
          path: "/gctc-portalsite/business",
          query: {
            value: "QYLN",
          },
        });
      } else if (val == "DDJS") {
        this.$router.push({
          path: "/gctc-portalsite/party",
          query: {
            value: "DJDT",
          },
        });
      } else if (val == "JYPT") {
        window.open("https://gsmtjyzx.com/ctp-web/", "_blank");
      } else if (val == "GYWM") {
        this.$router.push({
          path: "/gctc-portalsite/about",
          query: {
            value: "QYJS",
          },
        });
      }
    },
    handleSearch() {
      this.$router.push({
        path: "/gctc-portalsite/searchNews",
        query: { value: this.searchWords },
      });
    },
    // 供应链金融
    handleFinance(){
      window.open("https://gsmtjyzx.com/gctc-finance/#/gctc-finance", "_blank");
    },
    handleData(){
      // this.$router.push("/gctc-portalsite/dataAnalysis")
      let path = "/gctc-portalsite/dataAnalysis"
      const { href } = this.$router.resolve({
        //path是要跳转到的页面路径
        path: path,
      });
      //结合open打开新的页面
      window.open(href, "_blank");
    },
    handleLogis(){
      window.open("https://gsmtjyzx.com/gctc-logis", "_blank");
    },
    handleIntell(){
      // this.$router.push("/gctc-portalsite/intelligent")
      let path = "/gctc-portalsite/intelligent"
      const { href } = this.$router.resolve({
        //path是要跳转到的页面路径
        path: path,
      });
      //结合open打开新的页面
      window.open(href, "_blank");
    },
    handleInfor(){
      // this.$router.push("/gctc-portalsite/information")
      let path = "/gctc-portalsite/information"
      const { href } = this.$router.resolve({
        //path是要跳转到的页面路径
        path: path,
      });
      //结合open打开新的页面
      window.open(href, "_blank");
    },
    handleFinance(){
      window.open("https://gsmtjyzx.com/gctc-finance/#/gctc-finance", "_blank");
    },
    handleBuy(){
      window.open("http://www.gsnhcg.com/", "_blank");
    },
  },
};
</script>
<style lang="less" scoped>
@import "../style/global-style.css";
.el-submenu.is-active{
  background: #fff !important;
  color: #108ee9 !important;
}
.el-submenu.is-active span{
  background: #fff !important;
  color: #108ee9 !important;
  display: block;
  text-align: center;
}
.menu_height.is-active{
  background: #fff !important;
  color: #108ee9 !important;
}
.menu_height.is-active span{
  background: #fff !important;
  color: #108ee9 !important;
  display: block;
  text-align: center;
}
.el-menu-item{
  text-align: center;
}
.el-submenu span{
  display: block;
  text-align: center;
}
.menu-item01{
  text-align: center;
  color: #fff;
  line-height: 36px;
}
.menu-item01:hover{
  background: #0d72ba;
  cursor: pointer;
}
.wrapper {
  width: 100%;
}
.logo {
  width: 1200px;
  margin: 0 auto;
}
.logo:after {
  display: block;
  visibility: hidden;
  height: 0;
  font-size: 0;
  content: ".";
  clear: both;
}
.logoStart {
  float: left;
  text-align: start;
}
.wrapMenu {
  // margin-top: -3.5px;
  width: 100%;
  // height: 65px;
  background: #108ee9;
}
.menu {
  width: 1200px;
  margin: 0 auto;
}
.el-menu.el-menu--horizontal {
  font-size: 18px;
  border-bottom: solid 0 #fff;
  // width: 100%;
}
.menu_height {
  width: 14.2%;
  // font-size: 18px;
}
.el-menu--horizontal > .el-menu-item {
  font-size: 18px;
}
.el-menu--horizontal > .el-menu-item a {
  line-height: 60px;
  vertical-align: top;
}
/deep/ .el-submenu__title {
  font-size: 18px !important;
  padding: 0 !important;
}
/deep/ .el-input-group--append .el-input__inner,
.el-input-group__prepend {
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
  height: 40px;
}
.index_search {
    width: 300px;
    height: 40px;
    margin-top: 57px;
    position: relative;
    background: none !important;
    border-radius: 0 !important;
}
/deep/ .el-input-group__append {
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
}
/deep/ .el-menu--horizontal > .el-submenu .el-submenu__title {
  // line-height: normal;
  // height: auto;
}
/deep/ .el-submenu__icon-arrow {
  display: none;
  width: 0 !important;
}

</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->


// WEBPACK FOOTER //
// src/components/Header.vue